<template>
    <div v-if="isOpen" class="modal fade show" aria-labelledby="manualAcceptanceTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                            <h1 class="mb-0">Set User Password</h1>
                            <button
                                @click="toggleModal"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>
                <hr class="mt-0">
                
                <div class="pb-2">
                    <vForm @submit="submit" :validation-schema="schema">
                        <div class="row gy-2 px-2">
                             <div class="col-12">
                                <label class="form-label" for="password">Password</label>
                                <div class="input-group">
                                    <vField
                                        v-model="formData.password"
                                        type="password"
                                        name="password"
                                        id="password"
                                        class="form-control" 
                                        placeholder="Password"
                                    />
                                    <ErrorMessage name="password" class="invalid-feedback d-block qcont"/>
                                </div>
                            </div>
                            <div class="col-12">
                                <label class="form-label" for="password_confirmation">Confirm Password</label>
                                <div class="input-group">
                                    <vField
                                        v-model="formData.password_confirmation"
                                        type="password"
                                        name="password_confirmation"
                                        id="password_confirmation"
                                        class="form-control" 
                                        placeholder="Confirm Password"
                                    />
                                    <ErrorMessage name="password_confirmation" class="invalid-feedback d-block qcont"/>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 text-center">
                            <hr class="mt-2">
                            <button :disabled="loading" type="submit" class="btn btn-primary me-1 mt-1 waves-effect waves-float waves-light">
                                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                Submit
                            </button>
                            <button @click.prevent="toggleModal" class="btn btn-outline-secondary mt-1 waves-effect">
                                Cancel
                            </button>
                        </div>
                    </vForm>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ManualAcceptanceModal',

    data: () => ({
        isOpen: false,
        loading: false,
        schema: {
            password: 'required|min:6',
            password_confirmation: 'required|confirmed:@password',
        },
    }),

    methods: {
        submit () {
            this.$emit('onSubmit')
        },
        toggleModal () {
            this.isOpen = !this.isOpen
        }
    },

    props: {
        formData: Object
    }
}
</script>
